export const commonConfig = {
  cancelIcon: {
    enabled: true,
    label: 'Close'
  }
};

export function waitForElement(
  selector: string,
  maxWaitTime = 5000,
  checkInterval = 100
): Promise<Element | null> {
  return new Promise((resolve) => {
    const startTime = Date.now();

    const checkElement = () => {
      const element = document.querySelector(selector);

      if (element) {
        resolve(element);
        return;
      }

      const elapsedTime = Date.now() - startTime;
      if (elapsedTime > maxWaitTime) {
        console.warn(`Element ${selector} not found after ${maxWaitTime}ms`);
        resolve(null);
        return;
      }

      setTimeout(checkElement, checkInterval);
    };

    checkElement();
  });
}